import API from '../../api';

const API_URI = '/v2/email_authorizations/send';

export default {
  send(email, referrer) {
    return API.request('post', API_URI, { email: email, referrer: referrer });
  }
}
